/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { remoteMcpListServers } from "../funcs/remoteMcpListServers.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListServersResult } from "../models/components/listserversresult.js";
import {
  ListRemoteMcpServersRequest,
  ListRemoteMcpServersSecurity,
} from "../models/operations/listremotemcpservers.js";
import { unwrapAsync } from "../types/fp.js";
export type RemoteMcpServersQueryData = ListServersResult;

export function prefetchRemoteMcpServers(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListRemoteMcpServersRequest | undefined,
  security?: ListRemoteMcpServersSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildRemoteMcpServersQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildRemoteMcpServersQuery(
  client$: GramCore,
  request?: ListRemoteMcpServersRequest | undefined,
  security?: ListRemoteMcpServersSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<RemoteMcpServersQueryData>;
} {
  return {
    queryKey: queryKeyRemoteMcpServers({
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function remoteMcpServersQueryFn(
      ctx,
    ): Promise<RemoteMcpServersQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(remoteMcpListServers(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyRemoteMcpServers(
  parameters: {
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "remoteMcp", "listServers", parameters];
}
